let ProductList = {
  WaterMeter: {
    serialStart: "W",
    name: "Flowie",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/t/2/assets/flowie-square_500x.png?202893",
  },
  Puck: {
    serialStart: "L",
    name: "Floodie",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/t/2/assets/floodie-square_500x.png?202893",
  },
  Humie: {
    serialStart: "M",
    name: "Humie",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/t/2/assets/floodie-square_500x.png?202893",
  },
  SumpPit: {
    serialStart: "S",
    name: "Sumpie",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/t/2/assets/sumpie-square_500x.png?202893",
  },
  Sentree: {
    serialStart: "T",
    name: "Sentree",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/t/2/assets/sentree-square_500x.png?202893",
  },
  Hubbie: {
    serialStart: "C",
    name: "Hubbie",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/products/SensorRelay_350x350.png?v=1582061958",
  },
  FlowieO: {
    serialStart: "E",
    name: "Flowie-O",
    image:
      "https://cdn.shopify.com/s/files/1/1204/3164/products/Flowie-O_350x350.png?v=1582061793",
  },
  Shuttie: {
    serialStart: "D",
    name: "Shuttie",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/t/2/assets/Shuttie_Render_x1000.png?208492",
  },
  Shuttie2: {
    serialStart: "K",
    name: "Shuttie2",
    image:
      "https://cdn.shopify.com/s/files/1/2203/4635/t/2/assets/Shuttie_Render_x1000.png?208492",
  },
};

export default ProductList;
